var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Idea",
    clipPath: "url(#clip0_758_1372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.61281 5.36026C7.54915 5.84142 5.88793 7.47797 5.38064 9.52956C4.87176 11.5877 5.45416 13.6856 6.93865 15.1413C7.46372 15.6563 7.77727 16.4817 7.77727 17.3493V17.4878C7.77727 18.0591 8.02653 18.5732 8.4218 18.9274V20.0659C8.4218 21.1321 9.28921 21.9995 10.3554 21.9995H11.6445C12.7106 21.9995 13.578 21.1321 13.578 20.0659V18.9274C13.9733 18.5732 14.2226 18.0591 14.2226 17.4878V17.3467C14.2226 16.4923 14.5529 15.6513 15.1061 15.0968C16.1989 14.0017 16.8007 12.5466 16.8007 10.9995C16.8007 7.30077 13.3731 4.48378 9.61281 5.36026ZM12.289 20.0659C12.289 20.4213 11.9998 20.7104 11.6445 20.7104H10.3554C10 20.7104 9.71086 20.4213 9.71086 20.0659V19.4214H12.289V20.0659ZM14.1936 14.1863C13.3928 14.9888 12.9335 16.1407 12.9335 17.3467V17.4878C12.9335 17.8432 12.6444 18.1323 12.289 18.1323H9.71086C9.35547 18.1323 9.06633 17.8432 9.06633 17.4878V17.3493C9.06633 16.1247 8.61976 14.9845 7.84116 14.221C6.68573 13.0879 6.23374 11.4498 6.63198 9.83898C7.02407 8.25313 8.30901 6.98787 9.90551 6.61568C12.8563 5.92762 15.5116 8.13037 15.5116 10.9995C15.5116 12.2028 15.0435 13.3345 14.1936 14.1863Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.98655 5.07623L4.16351 3.25324C3.91184 3.00153 3.50373 3.00153 3.25202 3.25324C3.0003 3.50495 3.0003 3.91302 3.25202 4.16473L5.07505 5.98772C5.32672 6.23944 5.73488 6.23944 5.98655 5.98772C6.23826 5.73601 6.23826 5.32794 5.98655 5.07623Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.26562 10.3555H0.644531C0.288578 10.3555 0 10.644 0 11C0 11.356 0.288578 11.6445 0.644531 11.6445H3.26562C3.62158 11.6445 3.91016 11.356 3.91016 11C3.91016 10.644 3.62158 10.3555 3.26562 10.3555Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.3555 10.3555H18.7344C18.3784 10.3555 18.0898 10.644 18.0898 11C18.0898 11.356 18.3784 11.6445 18.7344 11.6445H21.3555C21.7114 11.6445 22 11.356 22 11C22 10.644 21.7114 10.3555 21.3555 10.3555Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.748 3.25324C18.4964 3.00153 18.0883 3.00153 17.8365 3.25324L16.0135 5.07623C15.7618 5.3279 15.7618 5.73601 16.0135 5.98772C16.2652 6.23944 16.6733 6.23944 16.925 5.98772L18.748 4.16473C18.9997 3.91306 18.9997 3.50495 18.748 3.25324Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11 0C10.644 0 10.3555 0.288578 10.3555 0.644531V3.26562C10.3555 3.62158 10.644 3.91016 11 3.91016C11.356 3.91016 11.6445 3.62158 11.6445 3.26562V0.644531C11.6445 0.288578 11.356 0 11 0Z",
    fill: "#29185E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_1372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.042133f58cca5b00b2c2217e8a3a5973.svg";
export { ForwardRef as ReactComponent };